// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swiper":"swiper_M7AWE","cover":"cover_QZIWe","cover_next":"cover_next_llR3U","cover_prev":"cover_prev_rf8Yj"};